import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  ajustes = {
    mostrar_tutorial: true,
  };

  constructor() {}

  cargar_storage(itemName) {
    let promesa = new Promise((resolve, reject) => {
      if (localStorage.getItem(itemName)) {
        var retrievedObject = JSON.parse(localStorage.getItem(itemName));

        resolve(retrievedObject);
      } else {
        reject('No se encontro la informacion solicitada');
      }
    });

    return promesa;
  }

  guardar_storage(item, value) {
    let promesa = new Promise((resolve, reject) => {
      localStorage.setItem(item, JSON.stringify(value));
      resolve(true);
    });
  }

  eliminar_session() {
    localStorage.clear();
  }

  deleteItemFromStorage(itemName) {
    if (localStorage.getItem(itemName)) {
      localStorage.removeItem(itemName);
    }
  }
}
